/**
 * Types d'erreurs pour l'application Sphere
 * Définis localement dans shared/util pour éviter les dépendances vers le frontend
 */

// Types d'erreurs générales
export type ErrorSeverity = 'error' | 'warning' | 'info'
export type ErrorCategory =
  | 'auth'
  | 'validation'
  | 'network'
  | 'server'
  | 'unknown'

// Structure d'une erreur API
export interface ApiError {
  code: string
  message: string
  field?: string
}

// Erreur utilisateur formatée
export interface UserError {
  id?: string
  title?: string
  code: string
  message: string
  severity: ErrorSeverity
  category: ErrorCategory
  field?: string
}

// Erreur de champ de formulaire
export interface FieldError {
  field: string
  message: string
  code?: string
}

// Réponse d'erreur complète
export interface ErrorResponse {
  general?: UserError
  fields?: Record<string, FieldError>
}

// Codes d'erreur d'authentification
export enum AuthErrorCodes {
  // Login
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  ACCOUNT_LOCKED = 'ACCOUNT_LOCKED',
  ACCOUNT_DISABLED = 'ACCOUNT_DISABLED',
  TOO_MANY_ATTEMPTS = 'TOO_MANY_ATTEMPTS',
  // Register
  EMAIL_ALREADY_EXISTS = 'EMAIL_ALREADY_EXISTS',
  USERNAME_ALREADY_EXISTS = 'USERNAME_ALREADY_EXISTS',
  WEAK_PASSWORD = 'WEAK_PASSWORD',
  INVALID_EMAIL_FORMAT = 'INVALID_EMAIL_FORMAT',
  TERMS_NOT_ACCEPTED = 'TERMS_NOT_ACCEPTED',
  // Général
  NETWORK_ERROR = 'NETWORK_ERROR',
  SERVER_ERROR = 'SERVER_ERROR',
  UNAUTHORIZED = 'UNAUTHORIZED',
  FORBIDDEN = 'FORBIDDEN',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

export type AuthErrorCode = keyof typeof AuthErrorCodes;
